<template>
  <div class="stepper">
    <ul class="nav nav-tabs" role="tablist">
      <li
        v-for="item in this.getSteps"
        v-bind:key="item.scoped"
        role="presentation"
        :class="{
          active: item.step == value,
          completed: item.step < value,
        }"
        :style="'width:' + stepItemWidth"
      >
        <a
          class="persistant-disabled"
          :href="'javascript:void(0)'"
          data-toggle="tab"
          :aria-controls="'stepper-step-' + item.step"
          role="tab"
          title=""
          :data-original-title="'Passo ' + item.step"
          aria-expanded="true"
          @click.prevent="changeStep(item.step)"
        >
          <span class="round-tab">{{ item.step }}</span>
        </a>
        <div class="steppertitle">
          <span>{{ item.title }}</span>
        </div>
      </li>
    </ul>
  </div>
</template>

<style scoped>
.stepper > .nav > li > .steppertitle {
  margin-top: -16px !important;
  margin-bottom: 16px !important;
  margin-left: auto !important;
  margin-right: auto !important;
  text-align: center !important;
}
.stepper .nav-tabs {
  position: relative !important;
}
.stepper .nav-tabs > li {
  position: relative !important;
}
.stepper .nav-tabs > li:after {
  content: "" !important;
  position: absolute !important;
  background: #f1f1f1 !important;
  display: block !important;
  width: 100% !important;
  height: 5px !important;
  top: 30px !important;
  left: 50% !important;
  z-index: 1 !important;
}
.stepper .nav-tabs > li.completed::after {
  background: #005cc8 !important;
}
.stepper .nav-tabs > li:last-child::after {
  background: transparent !important;
}
.stepper .nav-tabs > li.active:last-child .round-tab {
  background: #005cc8 !important;
}
.stepper .nav-tabs > li.active:last-child .round-tab::after {
  content: "✔" !important;
  color: #fff !important;
  position: absolute !important;
  left: 0 !important;
  right: 0 !important;
  margin: 0 auto !important;
  top: 0 !important;
  display: block !important;
}
.stepper .nav-tabs [data-toggle="tab"] {
  width: 25px !important;
  height: 25px !important;
  margin: 20px auto !important;
  border-radius: 100% !important;
  border: none !important;
  padding: 0 !important;
  color: #f1f1f1 !important;
}
.stepper .nav-tabs [data-toggle="tab"]:hover {
  background: transparent !important;
  border: none !important;
}
.stepper .nav-tabs > .active > [data-toggle="tab"],
.stepper .nav-tabs > .active > [data-toggle="tab"]:hover,
.stepper .nav-tabs > .active > [data-toggle="tab"]:focus {
  color: #005cc8 !important;
  cursor: default !important;
  border: none !important;
}
.stepper .tab-pane {
  position: relative !important;
  padding-top: 50px !important;
}
.stepper .round-tab {
  width: 25px !important;
  height: 25px !important;
  line-height: 22px !important;
  display: inline-block !important;
  border-radius: 25px !important;
  background: #fff !important;
  border: 2px solid #005cc8 !important;
  color: #005cc8 !important;
  z-index: 2 !important;
  position: absolute !important;
  left: 0 !important;
  text-align: center !important;
  font-size: 14px !important;
}
.stepper .completed .round-tab {
  background: #005cc8 !important;
}
.stepper .completed .round-tab::after {
  content: "✔" !important;
  color: #fff !important;
  position: absolute !important;
  left: 0 !important;
  right: 0 !important;
  margin: 0 auto !important;
  top: 0 !important;
  display: block !important;
}
.stepper .active .round-tab {
  background: #fff !important;
  border: 2px solid #005cc8 !important;
}
.stepper .active .round-tab:hover {
  background: #fff !important;
  border: 2px solid #005cc8 !important;
}
.stepper .active .round-tab::after {
  display: none !important;
}
.stepper .disabled .round-tab {
  background: #fff !important;
  color: #f1f1f1 !important;
  border-color: #f1f1f1 !important;
}
.stepper .disabled .round-tab:hover {
  color: #7da0b8 !important;
  border: 2px solid #a6b1b3 !important;
}
.stepper .disabled .round-tab::after {
  display: none !important;
}
.stepper .nav-tabs {
  border: none !important;
  margin-bottom: 1em !important;
}
</style>

<script>
export default {
  name: "SantanderStepper",
  props: {
    value: {
      type: Number,
      default: 0,
    },
    steps: {
      type: Array,
      default: null,
    },
  },
  methods: {
    changeStep: function (step) {
      if (step == this.value) return;
      if (step < this.value) {
        this.$emit("previous", step);
      } else {
        this.$emit("next", step);
      }
    },
  },
  computed: {
    getSteps() {
      if (this.steps == null) return false;
      return this.steps;
    },
    stepItemWidth() {
      return (this.steps.length > 0 ? 100 / this.steps.length : 1) + "%";
    },
  },
};
</script>